export default __webpack_public_path__ + "static/media/trash-light.293c03fd.svg";